export const Role = Object.freeze({
  Admin: 'ROLE_ADMIN',
  Chairman: 'ROLE_CHAIRMAN'
})
